<template>
  <div>
    <div class="col-12 p0 py2 my1 break-word">
      <div class="m0 h5 bold caps">{{ user.firstname }}, SELECTIONNEZ VOS OPTIONS</div>
    </div>
    <div v-if="firstSession" class="col-12 p0 py2 my1 break-word">
      <div class="m0 h6 bold caps">{{ firstSession.nomActivite }}</div>
      <div class="m0 h6 bold">{{ frenchTime(firstSession.timestampDebutCreneau, "EEEE dd MMMM") }} / {{ frenchTime(firstSession.timestampDebutCreneau, "HH'h'mm") }} - {{ frenchTime(addSeconds(firstSession.timestampFinCreneau, 1), "HH'h'mm") }}</div>
    </div>

    <div class="col-12 white-bg p2">
      <div class="flex flex-wrap border-bottom">
        <div class="col-7">
          <div class="bold h5 m0 cond lower">{{ currentParticipant.tariff.label.toLowerCase() }}</div>
        </div>
        <div class="col-5 right-align">
          <span v-if="price > 0" class="bold h5 m0">{{ price }} € <span v-if="isRecurring" class="h3">/ mois</span></span>
          <span v-else class="bold h6 m0">OFFERT</span>
        </div>
      </div>

      <!-- MANDATORY OPTIONS -->
      <div v-if="optionsByType(optionTypes.MANDATORY).length" class="my2">
        <div class="bold h6 mb1">Obligatoire</div>
        <OptionLine
          v-for="(option, index) in optionsByType(optionTypes.MANDATORY)"
          :key="index"
          :option="option"
          :is-active="isOptionActive(option)"
          @manageOption="manageOption"
        />
      </div>

      <!-- OPTIONAL OPTIONS -->
      <div v-if="optionsByType(optionTypes.OPTIONAL).length" class="my2">
        <div class="bold h6 mb1">Suppléments</div>
        <EscapeOptionLine
          v-for="(option, index) in optionsByType(optionTypes.OPTIONAL)"
          :key="index"
          :option="option"
          :is-active="isOptionActive(option)"
          @manageOption="manageOption"
        />
      </div>
    </div>

    <div class="col-12 flex flex-wrap justify-between black-bg white p2">
      <div class="flex h5 caps">Montant Total</div>
      <div class="flex h5 caps">{{ totalPrice.toFixed(2) }} € </div>
    </div>
    <div class="flex flex-wrap">
      <div class="col-12 py3 flex justify-end items-center">
        <Button class="col-4 sm-col-12" :action="handleBack" text="Precedent" color="grey-bg" />
        <Button v-if="!loading" class="col-4 sm-col-12 ml2" :action="confirmOptions" text="Suivant" />
        <Button v-else class="col-4 sm-col-6 ml2" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import { isWithinInterval, format, addSeconds } from 'date-fns';
import EscapeOptionLine from '../../components/options/EscapeOptionLine';
import Button from '../../components/elements/Button';

import { changeToPage, injectCurrentParticipant } from '@/utils/logics';
import { optionTypes, frenchTime } from '@/utils/utils';

export default {
  components: {
    EscapeOptionLine,
    Button
  },
  data () {
    return {
      loading: false,
      optionTypes: optionTypes,
      currentParticipant: this.$store.state.currentParticipant,
      participantOptions: [],
      offerInfo: this.$store.state.offerInfo || null,
      availableOptions: this.$store.state.availableOptions
    };
  },
  computed: {
    isInternalSession () {
      return this.$store.state.siteInfo && this.$store.state.siteInfo.is_internal_session;
    },
    user () {
      return this.$store.state.user;
    },
    firstSession () {
      return this.$store.state.sessions?.items[0];
    },
    price () {
      const { tariff } = this.currentParticipant;
      return tariff.promo && Object.keys(tariff.promo).length !== 0 ? tariff.promo.discount_price.toFixed(2) : parseFloat(tariff.price / 100).toFixed(2);
    },
    options () {
      const computedOptions = [];

      if (this.offerInfo && this.offerInfo.options) {
        this.availableOptions.map(option => {
          const price = option.detail.prices.find(priceAux => priceAux.tariffCategoryCode === this.currentParticipant.tariff.tariffCategoryCode);
          if (price) {
            if (price.promotions && price.promotions.length) {
              option.promo = {};

              price.promotions.map(promo => {
                const startDate = new Date(promo.start_date);
                const endDate = new Date(promo.end_date);
                const now = new Date();
                let day_week = format(now, 'e');

                if (day_week === 1) {
                  day_week = 7;
                } else {
                  day_week -= 1;
                }

                const isBetween = isWithinInterval(now, {
                  start: startDate,
                  end: endDate
                });

                if (isBetween && promo.quantity_remaining > 0 && (promo.week_day === 0 || promo.week_day === day_week)) {
                  option.price = promo.discount_price.toFixed(2);
                  option.promo = promo;
                }
                return promo;
              });
            }
            computedOptions.push({
              ...option,
              price
            });
          }
          return null;
        });
      }

      return computedOptions;
    },
    isRecurring () {
      return this.offerInfo.detail.recurring;
    },
    totalPrice () {
      let price = 0;
      this.participantOptions.map(o => {
        price = parseFloat((o.price.price * o.quantity) / 100) + parseFloat(price);
      });
      return parseFloat(this.price) + parseFloat(price);
    }
  },
  created () {
    this.participantOptions = this.optionsByType(this.optionTypes.MANDATORY);
    if (!this.options.length) {
      this.confirmOptions();
    }
  },
  methods: {
    changeToPage,
    injectCurrentParticipant,
    addSeconds,
    frenchTime,
    optionsByType (type) {
      return this.options.filter(option => option.optionType === type).map(option => {
        option.quantity = option.quantity ? option.quantity : 1;
        return option;
      });
    },
    manageOption (option) {
      let optionIndex = null;
      if (this.isInternalSession) {
        optionIndex = this.participantOptions.findIndex(o => o.uuid === option.uuid);
      } else {
        optionIndex = this.participantOptions.findIndex(o => o.horanet_product.horanet_product_code === option.horanet_product.horanet_product_code);
      }
      if (optionIndex !== -1) {
        if (option.quantity === this.participantOptions[optionIndex].quantity || (option.quantity === 0 && option.optionType === this.optionTypes.OPTIONAL)) {
          this.participantOptions.splice(optionIndex, 1);
        } else {
          this.participantOptions[optionIndex] = option;
        }
      } else if (option.quantity > 0) {
        this.participantOptions.push(option);
      }
    },
    isOptionActive (option) {
      if (this.isInternalSession) {
        return this.participantOptions.some(o => o.uuid === option.uuid);
      }
      const { horanet_product } = option;
      return this.participantOptions.some(o => o.horanet_product.horanet_product_code === horanet_product.horanet_product_code);
    },
    async confirmOptions () {
      this.loading = true;
      this.currentParticipant.options = this.participantOptions;
      await this.injectCurrentParticipant({ ...this.currentParticipant, quantity: 1 });
      this.loading = false;
    },
    handleBack () {
      this.changeToPage('OfferList');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
